export default __webpack_public_path__ + "static/nathanielruiznowell-bbcf8bc520582d1fee24073800a561c1.png";